import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var courseDetailsRes;
export const courseDetailsTodo = createAsyncThunk('courseDetails', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/view_course_details',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "course_id": data.course_id,
                'course_availability': data.availability,
                "device_token": user_id.vdevice_token
            },
            mode: 'no-cors',
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return courseDetailsRes = res.data
    } catch (error) {
        return courseDetailsRes = error.response.data
    }
})


const courseDetailsSlice = createSlice({
    name: 'courseDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(courseDetailsTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('courseDetails', state.data)
            }
        });
        builder.addCase(courseDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default courseDetailsSlice.reducer; 